import { ModelMapper } from "@omni/types/utils/modelMapper";

import { SafetyDocumentCategory } from "@/utils/enums";

export interface SafetyInfoResponse {
    sdsUrl?: string;
    dopUrl?: string;
}

export type SafetyInfoDocumentModel = {
    url: string;
    type: SafetyDocumentCategory;
};

export const SafetyInfoDocument: ModelMapper<
    SafetyInfoResponse,
    Array<SafetyInfoDocumentModel>
> = (model) => {
    const output: Array<SafetyInfoDocumentModel> = [];
    if (model.sdsUrl) {
        output.push({
            url: model.sdsUrl,
            type: SafetyDocumentCategory.SDS
        });
    }
    if (model.dopUrl) {
        output.push({
            url: model.dopUrl,
            type: SafetyDocumentCategory.DOP
        });
    }
    return output;
};
